import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./scss/main.scss";
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';

Vue.use(VueI18n);

const messages = {
  en,
  fr
};

const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('l');
const savedLang = localStorage.getItem('locale');

let locale = 'en';

if (langParam === 'fr' || langParam === 'en') {
  locale = langParam;
  localStorage.setItem('locale', locale);
} else if (savedLang === 'fr' || savedLang === 'en') {
  locale = savedLang;
} else {
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.toLowerCase().startsWith('fr')) {
    locale = 'fr';
  }
}

const i18n = new VueI18n({
  locale,
  messages,
});

Vue.config.productionTip = false;
import Notifications from "vue-notification";
Vue.use(Notifications);
import LottieAnimation from 'lottie-web-vue'
Vue.use(LottieAnimation);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
